import React, { useEffect, useState, useRef } from 'react';
import InputMask from "react-input-mask";
import NavBar from '../_components/navbar';
import { connect, useDispatch } from "react-redux";
import { authActions, usuarioAction, usuarioDispositivoAction, empresaAction, prefeituraAction, fazendaAction } from '../_actions';
import WhatsAppIcon from '../imgs/whatsapp.svg'
import { withRouter } from '../_helpers/withRouter';
import { Link } from "react-router-dom";
import {
    Breadcrumb, BreadcrumbItem, Card, CardBody, CardHeader,
    Button, ButtonGroup, Container, Row, Col, FormGroup, Label, Input, Form, Table, Badge
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUndo, faCheck, faBell, faTrash, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import '././styles.css';
import Moment from 'react-moment';
import { stringUtils } from '../_utils';
import Swal from 'sweetalert2';
import Select from 'react-select';
import JoditEditor from "jodit-react";
import TIPO_SISTEMA from '../_utils/constants/tipoSistema';
import { Fazenda } from '../fazendas';

const UsuarioEdit = (props, { placeholder }) => {

    const { match: { params } } = props;
    const dispatch = useDispatch();
    const editor = useRef(null);
    const editorAssinatura = useRef(null);
    const [content, setContent] = useState('');
    const [contentAssinatura, setContentAssinatura] = useState('');
    const [, forceUpdate] = React.useState(0);
    const [idFazenda, setIdFazenda] = useState(0);
    const [, setTextFazenda] = useState('');

    const config = {
        readonly: false,
        placeholder: placeholder || 'Escreva uma observação',
        removeButtons: ['video', 'superscript', 'subscript', 'AboutJodit', 'print']
    }

    const configAssinatura = {
        readonly: false,
        placeholder: placeholder || 'Coloque aqui o link da assinatura'
    }

    useEffect(() => {
        dispatch(usuarioAction.onChangePropsObservacoes('observacoes', content))
    }, [content]);

    useEffect(() => {
        dispatch(usuarioAction.onChangePropsAssinatura('caminho_assinatura', contentAssinatura))
    }, [contentAssinatura]);

    useEffect(() => {

        const { match: { params } } = props;
        const { dispatch } = props;

        dispatch(empresaAction.getEmpresasSelected());
        dispatch(fazendaAction.getFazendaSelect());
        //dispatch(fazendaAction.getFazendasByIdUsuario(true, params.id));
        dispatch(prefeituraAction.getPrefeiturasSelectById());  //chama o método que popula a combo de prefeituras por usando o Id em vez 
        //da IE

        if (params.id) {
            if (authActions.isGestor() || localStorage.getItem("id_user") === params.id) {
                dispatch(usuarioAction.getUsuarioById(params.id, true));

                dispatch(usuarioDispositivoAction.getUsuarioDispositivo(params.id));

            } else {
                props.history.push('/usuarios/');
            }
        } else {
            if (authActions.isGestor() === false) {
                props.history.push('/usuarios/');
            } else {
                dispatch(usuarioAction.clear());
            }
        }

    }, []);

    useEffect(() => {
        console.log('props.usuario.listaFazendas', props.usuario.listaFazendas);
    }, [props.usuario.listaFazendas]);

    const handleSelectChange = prop => event => {
        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };
        dispatch(usuarioAction.onChangeProps(prop, event2));
    };

    const handleChange = prop => event => {
        dispatch(usuarioAction.onChangeProps(prop, event));
        // dispatch(usuarioDispositivoAction.onChangeProps(prop, event));

        const { match: { params } } = props;
        if (params.id === null || params.id === 0) {

            if (prop === 'nome') {

                if (event.target.value.split(' ').length > 1) {

                    var fullName = event.target.value.split(' '),
                        firstName = fullName[0],
                        lastName = fullName[fullName.length - 1];

                    var event2 = {
                        target: {
                            value: stringUtils.removeDiacritics(firstName.toLowerCase() + '.' + lastName.toLowerCase())
                        }
                    };
                    dispatch(usuarioAction.onChangeProps('login', event2));

                } else {

                    var event3 = {
                        target: {
                            value: stringUtils.removeDiacritics(event.target.value.toLowerCase())
                        }
                    };
                    dispatch(usuarioAction.onChangeProps('login', event3));

                }
            }
        }
    };

    const hasUpper = (str) => /[A-Z]/.test(str);

    const handleValidation = () => {
        var valid = true;
        var errors = '';

        if (props.usuario.tipo === null || props.usuario.tipo === '') {
            valid = false;
            errors += '<li style="float:left;">Informe o Tipo de Usuário</li><br>';
        }

        if (props.usuario.nome === null || props.usuario.nome === '') {
            valid = false;
            errors += '<li style="float:left;">Informe o Nome</li><br>';
        }

        if (props.usuario.login === null || props.usuario.login === '') {
            valid = false;
            errors += '<li style="float:left;">Informe o Login</li><br>';
        }

        if ((props.usuario.login != null || props.usuario.login != '') && hasUpper(props.usuario.login) === true) {
            valid = false;
            errors += '<li style="float:left;">Informe um Login válido! São permitidas somente letras minúsculas</li><br>';
        }

        if (props.usuario.email === null || props.usuario.email === '') {
            valid = false;
            errors += '<li style="float:left;">Informe o E-mail</li><br>';
        }
        if (props.usuario.telefone !== null && props.usuario.telefone !== '' && props.usuario.telefone.replace(/\D/g, '').length !== 10 && props.usuario.telefone.replace(/\D/g, '').length !== 11) {
            valid = false;
            errors += '<li style="float:left;">Informe um Telefone válido</li><br>';
        }

        if (!valid) {
            Swal.fire({
                icon: 'warning',
                title: 'Erros de validação',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>'
            });
        }
        return valid;
    };

    const handleSubmit = event => {

        event.preventDefault();
        const { match: { params } } = props;

        if (handleValidation()) {

            let payload = {
                id: params.id,
                login: props.usuario.login.trim(),
                nome: props.usuario.nome,
                senha: props.usuario.senha || '',
                usuario_cadastro: props.authentication.user.id,
                tipo: props.usuario.tipo,
                email: props.usuario.email.trim(),
                telefone: props.usuario.telefone ? props.usuario.telefone.replace(/\D/g, '') : null,
                observacoes: props.usuario.observacoes,
                id_empresa: props.usuario.id_empresa ? props.usuario.id_empresa : null,
                caminho_assinatura: props.usuario.caminho_assinatura ? props.usuario.caminho_assinatura.replace('<p>', '').replace('</p>', '') : null,
                id_prefeitura: props.usuario.id_prefeitura ? props.usuario.id_prefeitura : null,
                modulo_financeiro: props.usuario.modulo_financeiro,
                listaFazendas: props.usuario.listaFazendas,

            };

            if (params.id) {
                dispatch(usuarioAction.editUsuarioInfo(params.id, payload, true));

            } else {
                dispatch(usuarioAction.createUsuario(payload, true));
            }
        }
    };

    const handleEnviaNotificacao = (id) => {

        var formData = new FormData();
        formData.append('id_dispositivo', id);
        formData.append('chave', 'gestorrp');

        dispatch(usuarioDispositivoAction.enviaNotificacao(true, formData));
    };

    const handleRemoverDispositivo = (id, id_usuario) => {
        dispatch(usuarioDispositivoAction.deleteDispositivoById(id, true, id_usuario));
    };

    const renderOptionsEmpresas = () => {
        const { match: { params } } = props;
        return props.empresa.empresa.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const renderOptionsFazendas = () => {
        return props.fazenda?.fazenda?.map((p, i) => {
            return (
                { value: p.id, label: p.nome }
            );
        });
    };

    const handleSelectChangeState = prop => event => {
        setIdFazenda(event.value);
        setTextFazenda(event.label);
    };

    const renderOptionsPrefeituras = () => {
        const { match: { params } } = props;
        return props.prefeitura.prefeitura.map((p, i) => {
            return (
                {
                    value: p.Value, label: p.Text,
                }
            );
        });
    };

    const handleRemoveOnList = id => {
        props.usuario.listaFazendas = props.usuario.listaFazendas.filter(ts => ts.id_fazenda !== parseInt(id));
        forceUpdate(n => !n);
    };

    function getFazendaNome(id) {
        var fazenda = props.fazenda.fazenda.filter(u => u.id == id);
        if (fazenda[0] != null) {
            return fazenda[0].nome;
        }
        else {
            return '';
        }
    }

    const handleAddOnList = e => {
        console.log('idFazenda', idFazenda)
        if (props.usuario.listaFazendas?.filter(ts => ts.id_fazenda === parseInt(idFazenda)).length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Erro ao adicionar',
                showCloseButton: true,
                showConfirmButton: true,
                html: '<div style="font-size: 14px; text-align: center">Fazenda já existe!</div>'
            });
        }
        else {
            if (idFazenda !== '' && idFazenda !== '0' && idFazenda != 0 && idFazenda) {
                props.usuario.listaFazendas.push({ 'id_fazenda': idFazenda, 'data_cadastro': '1900-01-01T00:00:00', 'id_usuario': params.id });
                forceUpdate(n => !n);
                setIdFazenda(0);
                setTextFazenda('');
            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Erro ao salvar',
                    showCloseButton: true,
                    showConfirmButton: true,
                    html: '<div style="font-size: 14px; text-align: center">Informe ao menos uma fazenda!</div>'
                });
            }
        }
    }

    const renderOptionsTipo = () => {

        var tipoData = [];
        if (authActions.isGestor()) {
            tipoData = [
                { value: '', text: 'SELECIONE ...' },
                { value: 'U', text: 'Usuário' },
                { value: 'A', text: 'Administrador' },
                { value: 'E', text: 'Exportação' },
                { value: 'G', text: 'Gestor' },
                { value: 'I', text: 'Inseminador' },
                { value: 'P', text: 'Prefeitura' }
            ];
        } else {
            tipoData = [
                { value: '', text: 'SELECIONE ...' },
                { value: 'U', text: 'Usuário' },
                { value: 'A', text: 'Administrador' },
                { value: 'I', text: 'Inseminador' }
            ];
        }

        return tipoData.map((p, i) => {
            return (
                { value: p.value, label: p.text }
            );
        });
    };
    return (
        <div>
            <NavBar {...props} />
            <Container>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col md={12}>
                                <Breadcrumb>
                                    <BreadcrumbItem><a href="/usuarios">Lista de Usuários</a></BreadcrumbItem>
                                    <BreadcrumbItem active>Usuário {props.usuario.id}</BreadcrumbItem>
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Form onSubmit={(event) => handleSubmit(event)}>
                            <Row>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="left" for="tipo">Tipo *</Label>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            value={renderOptionsTipo().filter(function (option) {
                                                return option.value === (props.usuario.tipo || '');
                                            })}
                                            onChange={handleSelectChange('tipo')}
                                            isSearchable
                                            placeholder="Selecione..."
                                            id="tipo"
                                            name="tipo"
                                            options={renderOptionsTipo()}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label className="left" for="login">Login *</Label>
                                        <Input
                                            id="login"
                                            label="Login"
                                            className="form-control"
                                            value={props.usuario.login || ''}
                                            onChange={handleChange('login')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label className="left" for="nome">Nome *</Label>
                                        <Input
                                            id="nome"
                                            label="Nome"
                                            className="form-control"
                                            value={props.usuario.nome || ''}
                                            onChange={handleChange('nome')}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label className="left" for="senha">Senha</Label>
                                        <Input
                                            id="senha"
                                            label="Senha"
                                            className="form-control"
                                            type="password"
                                            value={props.usuario.senha || ''}
                                            onChange={handleChange('senha')}
                                            autoComplete="new-password"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label className="left" for="email">E-mail *</Label>
                                        <Input
                                            id="email"
                                            label="E-mail"
                                            className="form-control"
                                            value={props.usuario.email || ''}
                                            onChange={handleChange('email')}
                                        />
                                    </FormGroup>
                                </Col>
                                {params.id && props.usuario.telefone && props.usuario.telefone != '' ?
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="left" for="telefone">Telefone *</Label>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                                                <Input
                                                    id="telefone"
                                                    label="Telefone"
                                                    className="form-control"
                                                    mask={stringUtils.phoneMask(props.usuario.telefone)}
                                                    maskChar=" "
                                                    tag={InputMask}
                                                    value={props.usuario.telefone || ''}
                                                    onChange={handleChange('telefone')}
                                                    margin="normal"
                                                />
                                                <Link style={{ display: 'flex', marginLeft: 20, textDecoration: 'none' }} color="#FFFFFF" to={{ pathname: `https://wa.me/55${props.usuario.telefone}` }} target="_blank" key={props.usuario.id}> <img src={WhatsAppIcon} alt="whatsapp" color="#000" style={{ width: 22 }} /></Link>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    :
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="left" for="telefone">Telefone *</Label>
                                            <Input
                                                id="telefone"
                                                label="Telefone"
                                                className="form-control"
                                                mask={stringUtils.phoneMask(props.usuario.telefone)}
                                                maskChar=" "
                                                tag={InputMask}
                                                value={props.usuario.telefone || ''}
                                                onChange={handleChange('telefone')}
                                                margin="normal"
                                            />
                                        </FormGroup>
                                    </Col>
                                }
                                {authActions.isGestor() ?
                                    <Col md={3} lg={3}>
                                        <FormGroup>
                                            <Label className="left" for="modulo_financeiro">Módulo Financeiro</Label>
                                            <Input
                                                id="modulo_financeiro"
                                                label="Módulo Financeiro"
                                                type="checkbox"
                                                checked={props.usuario.modulo_financeiro}
                                                onChange={handleChange('modulo_financeiro')}
                                                style={{ justifyContent: 'left', alignItems: 'left', flex: 1, display: 'flex', marginLeft: '3px' }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                                }
                                {props.usuario.tipo === "I" ?
                                    <>
                                        <Col md="3">
                                            <FormGroup>
                                                <Label className="left" for="id_empresa">Empresa</Label>
                                                <Select
                                                    classNamePrefix="select"
                                                    className="form-control basic-single p-0 border-0"
                                                    value={renderOptionsEmpresas().filter(function (option) {
                                                        return option.value == props.usuario.id_empresa
                                                    })}
                                                    onChange={handleSelectChange('id_empresa')}
                                                    isSearchable
                                                    placeholder="Selecione..."
                                                    id="id_empresa"
                                                    name="id_empresa"
                                                    options={renderOptionsEmpresas()}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="12" style={{ paddingTop: '7px' }}>
                                            <FormGroup>
                                                <Label className="left" for="caminho_assinatura">Caminho assinatura</Label>
                                                <JoditEditor
                                                    id="caminho_assinatura"
                                                    ref={editorAssinatura}
                                                    value={params.id ? "<img src =\"" + props.usuario.caminho_assinatura + "\" width=\"200\" />" : props.usuario.caminho_assinatura}
                                                    config={configAssinatura}
                                                    tabIndex={1}
                                                    onBlur={newContent => setContentAssinatura(newContent)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </>
                                    : null}
                                {props.usuario.tipo === "P" ?
                                    <Col md="3">
                                        <FormGroup>
                                            <Label className="left" for="id_prefeitura">Prefeitura *</Label>
                                            <Select
                                                classNamePrefix="select"
                                                className="form-control basic-single p-0 border-0"
                                                value={renderOptionsPrefeituras().filter(function (option) {
                                                    return option.value == props.usuario.id_prefeitura || 0
                                                })}
                                                placeholder="Selecione..."
                                                onChange={handleSelectChange('id_prefeitura')}
                                                isSearchable
                                                id="id_prefeitura"
                                                name="id_prefeitura"
                                                options={renderOptionsPrefeituras()}
                                            />
                                        </FormGroup>
                                    </Col>
                                    : null}
                                <Col md="12" style={{ marginTop: 15 }}>
                                    <FormGroup>
                                        <Label className="left" for="observacoes">Observações </Label>
                                        <JoditEditor
                                            id="observacoes"
                                            ref={editor}
                                            value={props.usuario.observacoes}
                                            config={config}
                                            tabIndex={1}
                                            onBlur={newContent => setContent(newContent)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Col>
                                <h5>Relação de fazendas do usuário</h5>
                                <div>
                                    <Row >
                                        <Col className="ml-0 mt-3" md={9} >


                                            <Col className="mr-2" style={{ display: 'flex' }} md="10" lg="8">
                                                <Select
                                                    style={{ minWidth: '500px' }}
                                                    className="form-control basic-single p-0 border-0"
                                                    classNamePrefix="select"
                                                    value={renderOptionsFazendas().filter(function (option) {
                                                        return option.value === (idFazenda || '0');
                                                    })}
                                                    onChange={handleSelectChangeState('id_fazenda')}
                                                    isSearchable
                                                    placeholder="Selecione..."
                                                    id="id_fazenda"
                                                    name="id_fazenda"
                                                    options={renderOptionsFazendas()}
                                                />
                                                <Button style={{ width: '200px', marginLeft: '15px', backgroundColor: 'var(--primary-color)', border: 'none' }} name="btnFazendas" id="btnFazendas" className="btn" variant="contained" color="primary" component='a' onClick={handleAddOnList}>Adicionar <FontAwesomeIcon icon={faPlus} /></Button>
                                            </Col>

                                        </Col>
                                    </Row>

                                    {authActions.isGestor() && params.id ? (
                                        <Row className="mt-2">
                                            <Col>
                                                <FormGroup className="left ml-2">
                                                    <div className="selectgroup selectgroup-pills left">
                                                        <Row>
                                                            {
                                                                props.usuario?.listaFazendas?.map((n, index) => {
                                                                    return (
                                                                        (n.id_usuario !== '' && getFazendaNome(n.id_fazenda) != '' && getFazendaNome(n.id_fazenda) ?
                                                                            <Badge pill color="light" style={{ fontSize: 15, padding: 8, margin: 5, fontWeight: 400, display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center', border: '2px solid #007BFF' }}>
                                                                                <Link
                                                                                    style={{ textDecoration: 'none', color: '#0069D9' }}
                                                                                    to={{ pathname: `/fazenda/${n.id_fazenda}` }}
                                                                                    target="_blank"
                                                                                    key={`user-${index}`}
                                                                                >
                                                                                    {getFazendaNome(n.id_fazenda)}
                                                                                </Link>
                                                                                &nbsp;
                                                                                <Link
                                                                                    style={{ textDecoration: 'none', color: '#DC3545' }}
                                                                                    to="#"
                                                                                    onClick={() => handleRemoveOnList(n.id_fazenda)}
                                                                                    key={`remove-${index}`}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                                                </Link>
                                                                            </Badge>
                                                                            : null)
                                                                    );
                                                                })
                                                            }
                                                        </Row>
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    ) : (<span></span>)}

                                </div>
                            </Col>

                            {
                                authActions.isGestor() && props.usuario.id > 0 ?
                                    <Row>
                                        <Col>
                                            <h5>Relação de dispositivos do usuário</h5>
                                            <div>
                                                <Row className="mt-2">
                                                    <Col className="left ml-2">
                                                        <Table responsive style={{ width: '70%', marginLeft: 'auto', marginRight: 'auto' }}>
                                                            <thead>
                                                                {undefined !== props.usuario.listaDispositivos && props.usuario.listaDispositivos.length ?
                                                                    <tr>
                                                                        <th>Dispositivo</th>
                                                                        <th>Sistema</th>
                                                                        <th>Data de ativação</th>
                                                                        <th></th>
                                                                        <th></th>
                                                                    </tr>
                                                                    : null}
                                                            </thead>
                                                            <tbody>
                                                                {undefined !== props.usuario.listaDispositivos && props.usuario.listaDispositivos.length
                                                                    ? props.usuario.listaDispositivos.map((n) => {
                                                                        return (
                                                                            <tr key={n.id} lg={12} md={12} xl={12} xs={12} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                                                <td scope="row">
                                                                                    {n.marca} - {n.modelo}
                                                                                </td>
                                                                                <td scope="row">
                                                                                    {n.sistema == TIPO_SISTEMA.INSEMINADORES ? 'INSEMINADORES' : TIPO_SISTEMA.ZOOTECNICO ? 'ZOOTÉCNICO' : 'FINANCEIRO'}
                                                                                </td>
                                                                                <td scope="row">
                                                                                    {n.data_ativacao ?
                                                                                        <Moment format="DD/MM/YYYY">{n.data_ativacao}</Moment>
                                                                                        :
                                                                                        ''}
                                                                                </td>
                                                                                <td scope="row" >
                                                                                    <Button color="primary" onClick={() => handleEnviaNotificacao(n.id)}>
                                                                                        Enviar notificação de teste &nbsp;<FontAwesomeIcon icon={faBell} />
                                                                                    </Button>
                                                                                </td>
                                                                                <td scope="row" >
                                                                                    <Button color="danger" onClick={() => handleRemoverDispositivo(n.id, n.id_usuario)}>
                                                                                        Remover &nbsp; <FontAwesomeIcon icon={faTrash} />
                                                                                    </Button>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    : <tr>
                                                                        <td scope="row">
                                                                            Nenhum dispositivo vinculado.
                                                                        </td>
                                                                    </tr>}
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                    : null}


                            <br />
                            <Row>
                                <Col className="left" md="8" lg="6">
                                    <span>* Campos obrigatórios</span>
                                </Col>
                                <Col className="d-flex flex-row-reverse" md="4" lg="6">
                                    <ButtonGroup>
                                        <Button variant="contained" className="mr-1" color="secondary" component='a' href="/usuarios">Voltar <FontAwesomeIcon icon={faUndo} /></Button>
                                        <Button variant="contained" className="mr-1" color="primary" type="submit" style={{ backgroundColor: 'var(--primary-color)', border: 'none' }}>Salvar <FontAwesomeIcon icon={faCheck} /></Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
            </Container>
            
        </div >
    );
}

const mapStateToProps = (state) => {
    return state;
};

const connectedUsuarioEditPage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(UsuarioEdit));
export { connectedUsuarioEditPage as UsuarioEdit };